<template>
  <div class="auth-wait">
    <el-alert
      title="您提交的主体资料正在审核中，请耐心等待，我们会尽快完成审核。"
      type="info"
    />
    <div style="margin: 15px 0; text-align: center">
      <el-button type="primary" clstag="pageclick|keycount|license_reviewed_view|01" @click="gotoAuth">查看详情</el-button>
      <el-tooltip effect="dark" clstag="pageclick|keycount|license_reviewed_recall|01" content="撤回后须重新提交认证资料" placement="top-start">
        <el-button plain @click="revoke">撤回</el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { reSelectCertMethod } from '@/api/apis/auth';

export default {
  name: 'AuthWait',
  computed: {
    authType() {
      return this.$store.state.authType;
    },
  },
  methods: {
    gotoAuth() {
      this.$router.push({
        name: this.authType === 1 ? 'uploadAuth' : 'agentCert',
      });
    },
    async revoke() {
      const res = await reSelectCertMethod();
      const { code, message } = res;

      if (code === 200) {
        this.$router.push({ path: '/info/select' });
      } else {
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-wait {
  padding: 30px 20px 54px;
}
</style>
